import { Box } from '@gousto-internal/citrus-react'
import React from 'react'

import {
  BrandEndorsementsSection,
  EndlessVarietySection,
  EnvironmentalBenefitsSection,
  CustomerReviewsSection,
  HowItWorksSection,
  OurSuppliersSection,
  ValueYouCanTasteSection,
} from '@library/landing-pages'
import type { Recipe } from '@library/menu-service'
import { LandingPageAboveTheFold } from '../../landing-page-above-the-fold/src/LandingPageAboveTheFold'
import { useIsValueComprehensionEnabled } from './hooks/useIsValueComprehensionEnabled'

export type HomepageProps = {
  onSignupCTAClick: () => void
  signupCTA: string
  recipes: Recipe[]
}

export function Homepage({ signupCTA, onSignupCTAClick, recipes }: HomepageProps) {
  const isValueComprehensionEnabled = useIsValueComprehensionEnabled()

  return (
    <Box data-testid="homepage">
      <LandingPageAboveTheFold onCTAClick={onSignupCTAClick} signupCTA={signupCTA} />
      {isValueComprehensionEnabled && <CustomerReviewsSection />}
      <HowItWorksSection signupCTA={signupCTA} onCTAClick={onSignupCTAClick} />
      <ValueYouCanTasteSection signupCTA={signupCTA} onCTAClick={onSignupCTAClick} />
      <EndlessVarietySection
        signupCTA={signupCTA}
        onCTAClick={onSignupCTAClick}
        recipes={recipes}
      />
      <BrandEndorsementsSection />
      {isValueComprehensionEnabled ? (
        <OurSuppliersSection />
      ) : (
        <EnvironmentalBenefitsSection signupCTA={signupCTA} onCTAClick={onSignupCTAClick} />
      )}
    </Box>
  )
}
